import ReactGA from 'react-ga4';
import { env } from './env';

// Initialize GA with your measurement ID
export const initGA = () => {
  try {
    ReactGA.initialize(env.analytics.measurementId);
    console.log('Google Analytics initialized successfully');
  } catch (error) {
    console.error('Error initializing Google Analytics:', error);
  }
};

// Track pageview
export const trackPageView = (path: string) => {
  try {
    ReactGA.send({ hitType: "pageview", page: path });
    console.log(`Pageview tracked: ${path}`);
  } catch (error) {
    console.error('Error tracking pageview:', error);
  }
};

// Track events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  try {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};

// Track user properties
export const setUserProperties = (properties: Record<string, any>) => {
  try {
    ReactGA.set(properties);
  } catch (error) {
    console.error('Error setting user properties:', error);
  }
};

// Track exceptions
export const trackException = (description: string, fatal: boolean = false) => {
  try {
    // Using event tracking for exceptions in GA4
    ReactGA.event({
      category: 'Error',
      action: 'Exception',
      label: description,
      value: fatal ? 1 : 0
    });
  } catch (error) {
    console.error('Error tracking exception:', error);
  }
};

// Track user engagement time
export const trackEngagementTime = () => {
  try {
    // This is for enhanced measurement in GA4
    ReactGA.send({ hitType: "timing_complete" });
  } catch (error) {
    console.error('Error tracking engagement time:', error);
  }
};

// Track ecommerce transactions
export const trackPurchase = (transactionId: string, value: number, currency: string = 'INR', items: any[] = []) => {
  try {
    ReactGA.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
      items: items
    });
  } catch (error) {
    console.error('Error tracking purchase:', error);
  }
};

// Track traffic source attribution when users arrive from shared links
export const trackReferralTraffic = (source: string, medium: string, campaign: string) => {
  try {
    ReactGA.event({
      category: 'Traffic Source',
      action: 'Referral Visit',
      label: `${source}/${medium}/${campaign}`
    });
    
    // Set user properties for attribution
    setUserProperties({
      traffic_source: source,
      traffic_medium: medium,
      traffic_campaign: campaign,
      is_referred_user: true
    });
  } catch (error) {
    console.error('Error tracking referral traffic:', error);
  }
};

// Track new user acquisitions from referrals
export const trackUserAcquisition = (acquisitionChannel: string, referrer?: string) => {
  try {
    ReactGA.event({
      category: 'User Acquisition',
      action: 'New User',
      label: acquisitionChannel,
      value: 1
    });
    
    if (referrer) {
      setUserProperties({
        acquisition_referrer: referrer
      });
    }
  } catch (error) {
    console.error('Error tracking user acquisition:', error);
  }
};